"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetRangeSliderProgressColor = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = require("styled-components");
const styles_1 = require("./styles");
const GetRangeSliderProgressColor = (value) => {
    return (0, styled_components_1.css) `
    ${styles_1.RangeSliderInput} {
      background: linear-gradient(
        to right,
        ${theme_1.primary.light} 0%,
        ${theme_1.primary.light} ${value}%,
        ${theme_1.grayScale[300]} ${value}%,
        ${theme_1.grayScale[300]} 100%
      );
    }
  `;
};
exports.GetRangeSliderProgressColor = GetRangeSliderProgressColor;
//# sourceMappingURL=utils.js.map